import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';

class ProfileTabs extends Component {
    render() {
		const self = this,
			{ user } = self.props.state,
			totalCount = 0;
        const { isEmployeeHasAccessTo } = this.props;
        return (
			<div>
				{(user.userDetails && user.userDetails.typeOfUser === "customer" && user.userDetails.isAdmin) ||
					(isEmployeeHasAccessTo('Manage Users') || isEmployeeHasAccessTo('User Requests'))
					?<div className="tabs push" style={{position:"static"}}>
						<ul>
							<li className={this.props.selectedTab === "myProfile"?"selected":""}>
								<Link to="/profile/myProfile">My Profile</Link>
							</li>
							{((user.userDetails && user.userDetails.typeOfUser === "customer" && user.userDetails.isAdmin) || isEmployeeHasAccessTo('Manage Users')) && <li className={this.props.selectedTab === "manageUsers"?"selected":""}>
								<Link to="/profile/manageUsers">Manage Users</Link>
							</li>}
							{((user.userDetails && user.userDetails.typeOfUser === "customer" && user.userDetails.isAdmin) || isEmployeeHasAccessTo('User Requests')) && <li className={this.props.selectedTab === "userRequests"?"selected":""}>
								<Link className={(totalCount > 0?"importantText":null)} to="/profile/userRequests">User Requests {(totalCount > 0?"("+totalCount+")":null)}</Link>
							</li>}
						</ul>
					</div>
					:null
				}
			</div>
        );
    }
}
const mapStateToProps = (state) => {
    return {state};
};

ProfileTabs = connect(mapStateToProps)(ProfileTabs);
export default ProfileTabs;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Profile/ProfileTabs.js